import React, { useEffect, useState } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom';
import messages from '../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { showLoading } from 'react-global-loading';

const PriceForAnimalProductData = ({
    payload,
    districtCode,
    monthName,
    yearName,
    urbanAndRuralCommonItemPrice,
    userInfoObject,
    resetMothAndYearField,
    config,
    type,
    titlesData,
    priceTitle,
    othersTitle,
    storedLanguage
}) => {
    const navigate = useNavigate();
    const [itemData, setItemData] = useState({});
    const [areButtonsDisabled, setAreButtonsDisabled] = useState(false);

    let ItemSerialNumber = 0;
    let isDisable = false;

    // Add null checks

    const {
		isSaveBtnDisable,
		isSubmitBtnDisable,
		isAcceptBtnDisable,
		isRejectBtnDisable
	} = getButtonDisabledStates(payload, userInfoObject);


    let headQuarterRemark = [
        'Price is Too Low.',
        'Price is too High.',
        'Price does not match with unit.',
        'Price does not match with variety.',
        'Others.'
    ];
    let otherRemark = [
        'Production is low',
        'Production is high',
        'Less supply',
        'High supply',
        'Not Available.',
        'On sale.',
        'Seasonal effect',
        'Discounted Item',
        'Other.'
    ];

    useEffect(() => {
        if (urbanAndRuralCommonItemPrice) {
            const initialData = {};
            urbanAndRuralCommonItemPrice.forEach(group => {
                group.items.forEach(item => {
                    initialData[item.itemCode] = {
                        price: item.price,
                        // comments: item.comments,
                        statusFlag: item.statusFlag,
                        categoryCode: item.categoryCode, // Add categoryCode
                        comments: item.comments,
                        style: {
                            borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
                            borderStyle: 'solid',
                            borderWidth: '1px 1px 1px 3px'
                        },
                        isRequiredRemark: false,
                        isRejectStatus: item.statusFlag === '6'
                    };
                });
            });
            setItemData(initialData);
        }
    }, [urbanAndRuralCommonItemPrice]);


    const validateItemVariationPrice = (itemCode, field, newValue, average, variation) => {
        if (!isMonthAndYearEmpty(monthName, yearName)) {
            return;
        }

        let dynamicStylesForTextBox = {};
        let isRequiredRemark = false;


        if (newValue !== 0) {
            const dif = average * (variation / 100);
            if (variation === 0 || dif === 0) {
                return;
            }

            if (newValue > average + dif || newValue < average - dif) {
                toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
                dynamicStylesForTextBox = {
                    borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
                    borderStyle: 'solid',
                    borderWidth: '1px 1px 1px 6px',
                };
                newValue = dynamicStylesForTextBox;

                if (itemData[itemCode].comments === 'NO' || itemData[itemCode].comments === '') {
                    isRequiredRemark = true;
                }
            } else {
                dynamicStylesForTextBox = {
                    borderColor: '#dcdfe1',
                    borderStyle: 'solid',
                    borderWidth: '1px 1px 1px 6px',
                };
                isRequiredRemark = false;
                newValue = dynamicStylesForTextBox;
            }
        }

        setItemData((prevItemData) => ({
            ...prevItemData,
            [itemCode]: {
                ...prevItemData[itemCode],
                [field]: newValue,
                isRequiredRemark: isRequiredRemark,
            },
        }));
    };






    const handlePriceChange = (itemCode, field, newValue) => {
        if (!(isMonthAndYearEmpty(monthName, yearName))) {
            return;
        }

        let isRequiredRemark = false;

        if (field === 'price' && !isNumeric(newValue)) {
            toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
            newValue = '';
        }

        // if (field === 'comments' && itemData[itemCode].isRequiredRemark === false && newValue === '' && itemData[itemCode].comments === '') {
        //     isRequiredRemark = true;
        // }
        if(field==='comments' && itemData[itemCode].isRequiredRemark===false 
            && (newValue==='' || itemData[itemCode].comments==='' || 
            itemData[itemCode].style.borderColor==="rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red")){
              isRequiredRemark=true
           
            }

        setItemData(prevItemData => ({
            ...prevItemData,
            [itemCode]: {
                ...prevItemData[itemCode],
                [field]: newValue,
                'isRequiredRemark': isRequiredRemark
            }
        }));
    };

    const handleCheckboxChange = (itemCode, field, newValue) => {
        if (!(isMonthAndYearEmpty(monthName, yearName))) {
            return;
        }
        let isRequiredRemark = (itemData[itemCode]?.comments===''  || itemData[itemCode]?.comments==='NO' ? true : false); 
        setItemData(prevItemData => ({
            ...prevItemData,
            [itemCode]: {
                ...prevItemData[itemCode],
                [field]: !prevItemData[itemCode][field],
                'isRequiredRemark': isRequiredRemark
            }
        }));
    };

    const handleGetUrbanConsumerPriceFormData = async (e, buttonType) => {
        const customItemCodes = [];
        let check = 0;
        let statusFlag = '';

        
        if (!(isMonthAndYearEmpty(monthName, yearName))) {
            return;
        }
        let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
        
        for (let itemId in itemData) {

            let  requiredTextBoxField=false;

            let price = itemData[itemId].price;
            let comments = itemData[itemId].comments;
            let categoryCode = itemData[itemId].categoryCode; // Ensure categoryCode is used
            let isRequiredRemark = itemData[itemId].isRequiredRemark;
            let isRejectStatus = itemData[itemId].isRejectStatus;
            statusFlag = (itemData[itemId].statusFlag === '') ?
                clickButtonStatusFlag :
                itemData[itemId].statusFlag;

   

            if (buttonType === "REJECT" && isRejectStatus) {
                check++;
                if (isRequiredRemark) {
                    toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                    return false;
                }
                statusFlag = clickButtonStatusFlag
            }
            // if (buttonType === "ACCEPT") {
            //     statusFlag = clickButtonStatusFlag;
            // }

            if (buttonType === "ACCEPT" || buttonType === "SAVE" ) { //Accept Button click
                statusFlag = clickButtonStatusFlag;
            }
    
            if (buttonType === "SUBMIT") { //Submit Button click
                statusFlag = clickButtonStatusFlag;
            }

            if (price === '' || price === null) {
                toast.error(messages.CURRENT_PRICE_MSG, messages.COLOR_RED);
                return false;
            }
            if (isRequiredRemark && comments === 'NO') {
                toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                return false;
            }

            if (isRequiredRemark && comments === '') {
                toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                return false;
            }

            if (comments === '' || comments == null) {
                comments = '';
            }

            const customObject = {
                itemCode: itemId,
                Price: price,
                comments: comments,
                categoryCode: categoryCode, // Ensure categoryCode is included
                statusFlag: statusFlag
            };
            customItemCodes.push(customObject);
        };

        if (buttonType === "REJECT" && check === 0) {
            toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
            return false;
        }

        let postData = {
            itemCodes: customItemCodes,
            payload: {
                district_code: districtCode,
                month_name: monthName,
                year_name: yearName,
                buttonType: buttonType,
                statusButtonFlag: clickButtonStatusFlag
            }
        };

        showLoading(true);
        try {
            const response = await axios.post(`${API_URL}api/otherPrices/wholeSalePriceAnimalProductFormDataSaveToDB`, postData, config);
            if (response.data.status) {
                toast.success(response.data.message, messages.COLOR_RED);
                if (buttonType === 'ACCEPT') {
                    setAreButtonsDisabled(true);
                }
            }
        } catch (error) {
            console.error(error);
            toast.error('An error occurred while processing your request.', messages.COLOR_RED);
        } finally {
            showLoading(false);
            resetForm();

        }
    };

    const resetForm = () => {
        const initialData = {};

        if (urbanAndRuralCommonItemPrice) { // Check if urbanAndRuralCommonItemPrice is defined
            urbanAndRuralCommonItemPrice.forEach(group => {
                group.items.forEach(item => {
                    initialData[item.itemCode] = {
                        price: '',
                        comments: '',
                        style: '',
                        isRequiredRemark: false,
                        isRejectStatus: false
                    };
                });
            });
        }
        setItemData(initialData);
        resetMothAndYearField();
    };

    const checkBoxcheckedLength = () => {
        const filteredData = Object.fromEntries(
            Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
        );
        return Object.keys(filteredData).length;
    };



    return (
        <>
            {/* <ToastContainer /> */}
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className="text-center">{storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? priceTitle.hi.Category_Name : priceTitle.en.Category_Name}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? othersTitle.hi.ITEM_NAME : othersTitle.en.ITEM_NAME}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.UNIT : titlesData.en.UNIT}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? othersTitle.hi.CURRENT_PRICE : othersTitle.en.CURRENT_PRICE}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? othersTitle.hi.REMARKS : othersTitle.en.REMARKS}</th>
                                <th className="text-center">{storedLanguage === 'hi' ? othersTitle.hi.REJECT_STATUS : othersTitle.en.REJECT_STATUS}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {urbanAndRuralCommonItemPrice && urbanAndRuralCommonItemPrice.map((group, i) => (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td style={{ color: 'red' }}>{group.categoryID}</td>
                                        <td colSpan="3" style={{ color: 'red' }}>{group.categoryName}</td>
                                        <td colSpan="3"></td>
                                        {/* <td></td> */}
                                    </tr>
                                    {group.items.map((item, j) => {
                                        ItemSerialNumber++;
                                        if (checkBoxcheckedLength() > 0) {
                                            isDisable = true;
                                        } else if (isAcceptBtnDisable) {
                                            isDisable = true;
                                        }
                                        return (
                                            <tr key={`row-${i}-${j}`}>
                                                <td>{ItemSerialNumber}</td>

                                                <td>{item.categoryName}</td>


                                                <td>{item.itemName}</td>
                                                <td>{item.itemUnitName}</td>
                                                
                                                <td>
                                                    <input
                                                        type="text"
                                                        style={itemData[item.itemCode]?.style || {}}
                                                        className="form-control"
                                                        maxLength="12"
                                                        value={itemData[item.itemCode]?.price || ''}
                                                        onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
                                                        onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, item.varianceLimit)}
                                                    />
                                                </td>
                                                <td>
                                                    <select
                                                        name={`remark_${ItemSerialNumber}`}
                                                        id={`remark${ItemSerialNumber}`}
                                                        className="form-select"
                                                        value={itemData[item.itemCode]?.comments || ''}
                                                        onChange={e => handlePriceChange(item.itemCode, 'comments', e.target.value)}
                                                    >
                                                        <option value="">[---Select---]</option>
                                                        {userInfoObject.userLevel === "HEAD QUARTER" ?
                                                            headQuarterRemark.map((remarkItem, i) => (
                                                                <option key={i} value={remarkItem}>{remarkItem}</option>
                                                            ))
                                                            :
                                                            otherRemark.map((remarkItem, i) => (
                                                                <option key={i} value={remarkItem}>{remarkItem}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {itemData[item.itemCode]?.isRequiredRemark ? (
                                                        <div style={{ color: 'red', marginTop: '10px' }}>Please Select the Remark</div>
                                                    ) : ''}
                                                </td>
                                                <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                                                    <input
                                                        type="checkbox"
                                                        disabled= {userInfoObject.userLevel==='DISTRICT LEVEL' ||  userInfoObject.userLevel==='DIVISION LEVEL'}
                                                        onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.value)}
                                                        checked={itemData[item.itemCode]?.isRejectStatus || false}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-12 text-center pt-3">

                        <button
							onClick={(e) => handleGetUrbanConsumerPriceFormData(e, 'SAVE')}
							type="button"
							className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`}
						>
						 Save
						</button>

                        {(userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL') && (
                           
                           
                           <button 
							onClick={(e)=>handleGetUrbanConsumerPriceFormData(e,'SUBMIT')} 
							type="submit" 
							className={`btn btn_orange mx-1 ${isSubmitBtnDisable?'disabled':''}`}
							>
						    Submit
						    </button>
                           
                        )}

                        {userInfoObject.userLevel === 'HEAD QUARTER' && (
                            <>
                            
                            <button 
							onClick={(e)=>handleGetUrbanConsumerPriceFormData(e,'ACCEPT')} 
							type="button" 
							className={`btn btn_orange mx-1 ${isDisable ? 'disabled' : ''}`} 
							>
						    Accept
                            </button>

                            <button 
                                onClick={(e)=>handleGetUrbanConsumerPriceFormData(e,'REJECT')} 
                                type="button" 
                                className={`btn btn_orange mx-1 ${isRejectBtnDisable?'disabled':''}`}
                                >
                                Reject
                            </button>
                            
                            </>

                        )}
                        <button
                            type="reset"
                            className="btn btn_orange mx-1"
                            onClick={resetForm}
                        >
                            Reset
                        </button>
                        <button
                            type="button"
                            className="btn btn_orange mx-1"
                            onClick={(e) => (navigate("/dashboard"))}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PriceForAnimalProductData;
